module.exports = __webpack_public_path__ + "static/img/bg-product.76bbc858.png";